export default __webpack_public_path__ + "static/media/card-m-about@3x.d66693f2.png";